$(document).on('click', 'button[data-nav-search-desktop-toggle]', (event) => {
  const $form = $('[data-nav-search-desktop]');
  const $nav = $('[data-nav-items]');
  if ($form.is(':hidden')) {
    event.preventDefault();
    $form.show(700);
    $nav.hide(400);
    setTimeout(() => {
      $form.find('input').focus();
    }, 800);
  } else {
    event.stopPropagation();
  }
});
$(document).on('click', (event) => {
  const $form = $('[data-nav-search-desktop]');
  const $nav = $('[data-nav-items]');
  const $searchContainerElements = $('[data-desktop-search-container]').find('*');
  if ($form.is(':visible') && !$searchContainerElements.has(event.target).length) {
    $form.hide(450);
    $nav.show('fast');
  }
});
